import { useAlterStatusInventory } from '@/core/domain/inventory/inventories/inventory.hooks';
import {
  Inventory,
  InventoryStatus,
  ProductTypeLabels,
} from '@/core/domain/inventory/inventories/Inventory.types';

import { Button, Modal } from 'antd';

interface Props {
  inventory: Inventory;
}

const ImportAllItemsInventoryModal = ({ inventory }: Props) => {
  const alterStatusInventory = useAlterStatusInventory();

  const handleSave = () => {
    const title = `Importar ${ProductTypeLabels[inventory.productType].all} ${
      ProductTypeLabels[inventory.productType].lowercase
    } da base no inventário`;

    const content = `Caso a quantidade de ${
      ProductTypeLabels[inventory.productType].lowercase
    } do inventário seja muito grande, a importação será processada durante a noite e o inventário estará disponível apenas no dia seguinte.`;

    Modal.confirm({
      title,
      content,
      onOk: async () =>
        await alterStatusInventory.mutateAsync({
          id: inventory.id,
          status: inventory.status,
          populateInventory: true,
        }),
      okText: 'Importar',
    });
  };

  const btnText = `Importar  ${ProductTypeLabels[inventory.productType].all} ${
    ProductTypeLabels[inventory.productType].lowercase
  } para o inventário`;

  return (
    <Button
      type="primary"
      onClick={handleSave}
      disabled={
        inventory?.status === InventoryStatus.DONE ||
        inventory?.status === InventoryStatus.PROCESSING ||
        inventory?.status === InventoryStatus.IMPORTING
      }
    >
      {btnText}
    </Button>
  );
};

export default ImportAllItemsInventoryModal;
